// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

//ENUMS
// eslint-disable-next-line no-unused-vars
import { ExtraProductChooseType } from "@/enums/extraProductChooseType";
// eslint-disable-next-line no-unused-vars
import { ExtraProductObjectType } from "@/enums/extraProductObjectType";
// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## ExtraProduct Get
/**
 *
 * @param {{params: object, query: { extraProductRuleId: string,  "objectType": ExtraProductObjectType, "chooseType": ExtraProductChooseType, page: number, limit: number }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.ExtraProduct.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## ExtraProduct Create
/**
 *
 * @param {{ "extraProductRuleId": "string", "objectId": "string", "objectType": ExtraProductObjectType, "chooseType": ExtraProductChooseType, "limit": number, "maxLimit": number, "minLimit": number }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.ExtraProduct.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## ExtraProduct Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.ExtraProduct.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## ExtraProduct Update
/**
 *
 * @param {{ "extraProductRuleId": "string", "objectId": "string", "objectType": ExtraProductObjectType, "chooseType": ExtraProductChooseType, "limit": number, "maxLimit": number, "minLimit": number }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.ExtraProduct.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## ExtraProduct Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.ExtraProduct.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
